import { render } from "./FeaturePreviewSection.vue?vue&type=template&id=23fccdef"
import script from "./FeaturePreviewSection.vue?vue&type=script&lang=js"
export * from "./FeaturePreviewSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__